<template>
    <div class="btn favorite"></div>
</template>

<style scoped lang=scss>
    .favorite {
        background-image: url("~@/assets/img/fav-20.png");
        background-color: $btnBg;
        &:hover {
            background-image: url("~@/assets/img/fav-white-20.png");
        }
    }
</style>

<script>
    export default {
        name: 'favorite-btn',
        data() {
            return {
                
            }
        },
    }
</script>